import type { SVGProps } from 'react'
const LineLinkAlt01 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="m17.895 13.53-1.06-1.06 1.57-1.57c.71-.71 1.1-1.65 1.1-2.65s-.39-1.945-1.1-2.65a3.743 3.743 0 0 0-5.3 0l-1.57 1.57-1.06-1.06 1.57-1.57A5.22 5.22 0 0 1 15.755 3a5.2 5.2 0 0 1 3.71 1.54 5.22 5.22 0 0 1 1.54 3.71 5.2 5.2 0 0 1-1.54 3.71zm-2.677-5.808-7.499 7.499 1.06 1.06 7.5-7.498zM4.54 19.46A5.2 5.2 0 0 0 8.25 21c1.4 0 2.72-.55 3.71-1.54l1.57-1.57-1.06-1.06-1.57 1.57a3.743 3.743 0 0 1-5.3 0 3.71 3.71 0 0 1-1.1-2.65c0-1 .39-1.94 1.1-2.65l1.57-1.57-1.06-1.06-1.57 1.57A5.2 5.2 0 0 0 3 15.75c0 1.4.55 2.72 1.54 3.71"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineLinkAlt01 }
